if (!String.prototype.replaceAll) {
    String.prototype.replaceAll = function(search, replace) {
        if (search instanceof RegExp) {
            return this.replace(search, replace);
        }
        let r = '', i, j;
        while ((j = this.indexOf(search, i)) >= 0) {
            r += this.slice(i, j) + replace;
            i = j + search.length;
        }
        return r + this.slice(i);
    }
}
